/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { scheduleAllocationByResourceItemSchema } from './scheduleAllocationByResourceItemSchema';

export const scheduleAllocationByResourceEntrySchema = z.object({
  allocatedSeconds: z
    .int()
    .describe(
      "Planned seconds in the range, rounded half up once from the unrounded sum of the entry's items",
    ),
  itemCount: z.int(),
  get items() {
    return z
      .array(scheduleAllocationByResourceItemSchema)
      .describe(
        'Per-item planned seconds, sorted by itemId. Present only when includeItems is true. Each value is rounded on its own, so the values may not add up exactly to allocatedSeconds',
      )
      .nullish();
  },
  resourceId: z.int(),
  teamId: z.int(),
});
